import {login} from '@/helper/request.js'
const state = {
  adminInfo: sessionStorage.getItem("adminInfo") ? JSON.parse(sessionStorage.getItem("adminInfo")) : '',
  restaurant_infos: sessionStorage.getItem("restaurant_infos") ? JSON.parse(sessionStorage.getItem("restaurant_infos")) : '',
  logingState: 1 // 1登录 2未登录
}
const getters = {
  adminInfo: state => state.adminInfo,
  logingState: state => state.logingState,
  restaurant_infos: state => state.restaurant_infos
}

const actions = {
  async getadminInfo ({ commit }, userData) {
    console.log('调用store getadminInfo')
    const res = await login(userData)
    console.log(res)
    if (res.status_code == 200) {
      commit('GETUSER', res.data)
      return res
    } else {
      return res
    }
   
  }
}

const mutations = {
  'GETUSER' (state, resData) {
    state.logingState = 1
    state.adminInfo = resData
    sessionStorage.setItem("token", resData.token);
    sessionStorage.setItem("adminInfo", JSON.stringify(resData))
  },
  'SETRESTAURANTINFO' (state, resData) {
    state.restaurant_infos = resData
    sessionStorage.setItem("restaurant_infos", JSON.stringify(resData))
  },
}
console.log(getters, 'getters')
export default{
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/userInfo/index.js